export function getElementHeight(id: string) {
    const el = document.getElementById(id);
    if (!el) {
        return 0;
    }
    return Number(window.getComputedStyle(el).height.replaceAll("px", ""));
}

export function getNumber(value: string | number): number {
  if (typeof value === "string") {
    // If it's a string, convert it to a number
    return Number(value); 
  }
  // If it's already a number, return it as is
  return value;
}